import { render, staticRenderFns } from "./PageOrderHistory.vue?vue&type=template&id=2847fa86&scoped=true"
import script from "./PageOrderHistory.vue?vue&type=script&lang=js"
export * from "./PageOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./PageOrderHistory.vue?vue&type=style&index=0&id=2847fa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847fa86",
  null
  
)

export default component.exports